const api = 'https://api.lalie-landry.com'

const config = {
  siteName: 'Lalie Landry',
  apiBaseUrl: api,
  slideImageBaseUrl: api + '/upload/slides/' ,
  serieImageBaseUrl: api + '/upload/series/',
  novelImageBaseUrl: api + '/upload/novels/',
  eventImageBaseUrl: api + '/upload/events/',
  productImageBaseUrl: api + '/upload/products/',
  contactEmail: 'lalie@lalie-landry.com',
  contactMail: '',
  bddTrueValue: 1,
  bddFalseValue: 0,
  stripePublicKey: "pk_live_51SH11l3OTstV4z7rjn6rGZp6DE0Bh68bvbdKrqwXTPDqQ9h2CjyR3sUslvPV3mIgQbztpOJpckUA3vFpSSPcyFKD00pPhQQw1i",
  recaptchaSiteKey: "6LcM5JItAAAAAEmAmB96TeJp-UHyIyH64ep6ZqWd",
}

export default config